import React from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Im from "immutable";
import { calculateFields } from "../asset/calculations";

const processData = (
  data,
  companyId,
  onSuccess,
  type,
  ShareProductButton,
  CopyProductToDraftButton,
) => {
  console.log(data?.toJS(), "dataInCatalogTable");
  return data?.map((item) => {
    const { totals: values } = calculateFields({ data: item.toJS() }) || {};

    const reformatted = {
      id: item?.get(`product_id`),
      assetName: item?.get("details")?.get("name"),
      supplierName: item?.get("details")?.get("company_name"),
      category: item?.get("details")?.get("category"),
      totalKgCO2e: values?.total,
      a1A2kgCO2e: values?.a1 + values?.a2,
      a3kgCO2e: values?.a3,
      a4kgCO2e: values?.a4,
      b8kgCO2e: values?.b8,
    };

    if (type === "product") {
      reformatted.shareProduct = (
        <ShareProductButton
          companyId={companyId}
          product={item?.toJS()}
          onSuccess={onSuccess}
        />
      );

      reformatted.copyProduct = (
        <CopyProductToDraftButton
          companyId={companyId}
          product={item?.toJS()}
          onSuccess={onSuccess}
        />
      );
    }
    return reformatted;
  });
};

const tableCustomStyles = {
  rows: {
    style: {
      minHeight: "45px !important",
    },
  },
  headCells: {
    style: {
      fontWeight: "bold",
    },
  },
};

export function CatalogTable({
  data,
  companyId,
  onSuccess,
  type,
  ShareProductButton,
  CopyProductToDraftButton,
  sharedAsset = false,
}) {
  const processedData = processData(
    data,
    companyId,
    onSuccess,
    type,
    ShareProductButton,
    CopyProductToDraftButton,
  );

  const columns = [
    {
      name: "Asset Name",
      selector: (row) => {
        return (
          <Link to={`/company/${companyId}/asset/${type}/${row.id}`}>
            {row.assetName}
          </Link>
        );
      },
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Total (kgCO2e)",
      selector: (row) => row.totalKgCO2e?.toFixed(2),
      sortable: true,
    },
    {
      name: "A1-A2 (kgCO2e)",
      selector: (row) => row.a1A2kgCO2e?.toFixed(2),
      sortable: true,
    },
    {
      name: "A3 (kgCO2e)",
      selector: (row) => row.a3kgCO2e?.toFixed(2),
      sortable: true,
    },
    {
      name: "A4 (kgCO2e)",
      selector: (row) => row.a4kgCO2e?.toFixed(2),
      sortable: true,
    },
    {
      name: "B8 (kgCO2e)",
      selector: (row) => row.b8kgCO2e?.toFixed(2),
      sortable: true,
    },
  ];

  if (type === "product") {
    columns.push({
      name: "Copy",
      button: true,
      cell: (row) => row.copyProduct,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      grow: 0,
    });
    columns.push({
      name: "Share",
      button: true,
      cell: (row) => row.shareProduct,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      grow: 0,
    });
  }

  if (sharedAsset) {
    columns.splice(1, 0, {
      name: "Supplier",
      selector: (row) => row.supplierName,
      sortable: true,
    });
  }

  return (
    <DataTable
      columns={columns}
      data={processedData?.toJS()}
      noDataComponent="No records"
      dense={false}
      customStyles={tableCustomStyles}
    />
  );
}
